const thousands = function (value, decimalPlaces = 0, separator = ",") {
  value = value * 1;
  let wholeNumber = value.toFixed(0);
  const decimals = decimalPlaces
    ? value.toFixed(decimalPlaces).split(".").pop()
    : null;
  const batches = [];
  let rounds = 0;
  while (rounds < 10 && wholeNumber.length > 3) {
    rounds++;
    batches.unshift(wholeNumber.slice(-3));
    wholeNumber = wholeNumber.replace(/.{3}$/, "");
  }
  batches.unshift(wholeNumber);
  wholeNumber = batches.join(separator);
  if (decimals) wholeNumber = `${wholeNumber}.${decimals}`;
  return wholeNumber;
};
module.exports = thousands;
// export default thousands
